import React from 'react'
import ModalAlert from 'src/components/ModalAlert'

const ModalWithdrawSuccess = ({ show, action }) => (
  <ModalAlert
    show={show}
    action={action}
    centered
    title="Mensagem de confirmação"
    message="Saída realizada com sucesso."
  />
)

export default ModalWithdrawSuccess
